import { PageHeader } from 'ui/pageHeader';
import { useTranslation } from 'modules/domains/list';

import { PageActions } from './PageActions';

export const Header = () => {
  const { t } = useTranslation();
  return <PageHeader pageActions={<PageActions />}>{t('indexPage.title')}</PageHeader>;
};
